module.exports = __webpack_public_path__ + "img/chat-user1.2ee6f779.png";